"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOTION = exports.DOCUMENT = exports.PAYMENT = exports.MEETING = void 0;
var MEETING = 'meeting';
exports.MEETING = MEETING;
var PAYMENT = 'payment';
exports.PAYMENT = PAYMENT;
var DOCUMENT = 'document';
exports.DOCUMENT = DOCUMENT;
var MOTION = 'motion';
exports.MOTION = MOTION;